/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { DeviceCurrentRetrieveStatus200 } from "../types/DeviceCurrentRetrieve.ts";

function getDeviceCurrentRetrieveUrl() {
	const res = { method: "GET", url: `/api/device/current/` as const };

	return res;
}

/**
 * @description Представление вывода инфо об устройстве.
 * {@link /api/device/current/}
 */
export async function deviceCurrentRetrieve(config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<DeviceCurrentRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getDeviceCurrentRetrieveUrl().url.toString(),
		...requestConfig,
	});

	return res.data;
}
